(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-catalog-grid"] && !Shopify.designMode) return;
  try {
    (() => {
  const sortColorCards = () => {
    document.querySelectorAll('.ss-catalog-grid').forEach(grid => {
      const cards = Array.from(grid.children);
      cards.sort((a, b) => Number(b.dataset.ssPrice) - Number(a.dataset.ssPrice));
      cards.forEach(card => grid.appendChild(card));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sortColorCards, {once: true});
  else sortColorCards();
  document.addEventListener('shopify:section:load', sortColorCards);
})();
  } catch(e) { console.error(e); }
})();

})();
